import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  return {
    dialogTitle: {
      color: theme.palette.blue_300?.main || theme.palette.blue_300.main
    },
    description: {
      color: isDark
        ? theme.palette.dark_50?.main
        : theme.palette.gray_400?.main,
      fontSize: '.875rem',
      marginTop: theme.spacing(0.5)
    },
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1), // Espaçamento moderno entre itens da lista
      padding: theme.spacing(1, 0)
    },
    listItem: {
      padding: '4px 12px !important',
      borderRadius: '8px',
      marginBottom: theme.spacing(1),
      transition: theme.transitions.create(
        ['border-color', 'background-color', 'color'],
        {
          duration: theme.transitions.duration.short
        }
      ),
      backgroundColor: isDark
        ? theme.palette.dark_400?.main
        : theme.palette.white_100?.main,
      border: `1px solid ${isDark ? theme.palette.dark_400?.main : theme.palette.white_100?.main}`,
      color: isDark
        ? theme.palette.dark_50?.main
        : theme.palette.gray_400?.main,

      '& .MuiListItemText-root': {
        margin: '0px !important'
      },

      '&:hover': {
        color: theme.palette.white_100?.main,
        backgroundColor: theme.palette.blue_300?.main,
        borderColor: theme.palette.blue_300?.main
      },

      // Regra aplicada quando o item está selecionado
      '&.Mui-selected': {
        backgroundColor: isDark
          ? theme.palette.dark_400?.main
          : theme.palette.white_100?.main,
        borderColor: theme.palette.blue_300?.main || theme.palette.blue_300.main,

        '&:hover': {
          color: theme.palette.white_100?.main,
          backgroundColor: isDark
            ? theme.palette.dark_400?.main
            : theme.palette.white_100?.main,
          borderColor: theme.palette.blue_300?.main
        }
      }
    },
    statusIconConnected: {
      color: theme.palette.success.main, // Verde nativo do tema
      marginLeft: theme.spacing(1)
    },
    statusIconDisconnected: {
      color: theme.palette.error.main, // Vermelho nativo do tema
      marginLeft: theme.spacing(1)
    }
  }
})
